
export default function Parcours() {
  const milestones = [
    {
      period: 'Aujourd\u2019hui',
      role: 'Fondateur — Usine \u00e0 Leads',
      description:
        'Cr\u00e9ation d\u2019une agence sp\u00e9cialis\u00e9e en g\u00e9n\u00e9ration de leads qualifi\u00e9s. Acquisition, conversion et automatisation pour PME et ind\u00e9pendants.',
      impact: 'Syst\u00e8mes g\u00e9n\u00e9rant +47\u00a0% de leads en 90 jours',
      icon: 'ri-rocket-line',
      color: 'from-orange-500 to-orange-600',
    },
    {
      period: '15+ ans',
      role: 'Expert Digital & E-commerce',
      description:
        'Accompagnement de marques et retailers dans leur transformation digitale : strat\u00e9gie omnicanale, e-commerce, marketing digital et pilotage de la performance.',
      impact: 'Dizaines de projets de transformation r\u00e9ussis',
      icon: 'ri-store-line',
      color: 'from-teal-500 to-teal-600',
    },
    {
      period: 'Exp\u00e9rience',
      role: 'Conseil en strat\u00e9gie & Brand Consulting',
      description:
        'Missions de conseil strat\u00e9gique pour des groupes internationaux : positionnement, go-to-market, business models digitaux et conduite du changement.',
      impact: 'Strat\u00e9gies d\u00e9ploy\u00e9es dans +10 pays',
      icon: 'ri-global-line',
      color: 'from-emerald-500 to-emerald-600',
    },
    {
      period: 'Formation',
      role: 'ESSCA \u00c9cole de Management',
      description:
        'Formation sup\u00e9rieure en management, marketing et strat\u00e9gie d\u2019entreprise. Une base solide pour comprendre les enjeux business de chaque client.',
      impact: 'Double comp\u00e9tence business & digital',
      icon: 'ri-graduation-cap-line',
      color: 'from-gray-600 to-gray-700',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-gray-50 overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <header className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Un parcours au service de <strong className="text-orange-600">votre croissance</strong>
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            20 ans \u00e0 combiner vision strat\u00e9gique et ex\u00e9cution op\u00e9rationnelle pour g\u00e9n\u00e9rer des r\u00e9sultats concrets
          </p>
        </header>

        {/* Timeline */}
        <div className="relative max-w-4xl mx-auto">
          {/* Vertical line */}
          <div className="absolute left-6 sm:left-8 top-0 bottom-0 w-px bg-gray-200" />

          <div className="space-y-8 sm:space-y-10">
            {milestones.map((m, i) => (
              <article
                key={i}
                className="relative flex gap-5 sm:gap-8 group"
              >
                {/* Icon dot */}
                <div className="relative z-10 flex-shrink-0">
                  <div
                    className={`w-12 h-12 sm:w-16 sm:h-16 rounded-2xl bg-gradient-to-br ${m.color} flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300`}
                  >
                    <i className={`${m.icon} text-xl sm:text-2xl text-white`} />
                  </div>
                </div>

                {/* Content card */}
                <div className="flex-1 bg-white rounded-2xl p-5 sm:p-7 shadow-md border border-gray-100 group-hover:shadow-xl group-hover:border-orange-100 transition-all duration-300">
                  <span className="text-xs font-bold text-orange-600 uppercase tracking-wider">
                    {m.period}
                  </span>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mt-1 mb-2">
                    {m.role}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed mb-3">
                    {m.description}
                  </p>
                  <div className="inline-flex items-center gap-2 text-sm font-semibold text-emerald-600 bg-emerald-50 px-3 py-1.5 rounded-full">
                    <i className="ri-line-chart-line" />
                    <span>{m.impact}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
